// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressDetails_container__fWfC4"};